import React from 'react'

export const Train = ({ fill }) => (
<svg width="56.6929px" height="34.1174px" viewBox="0 0 56.6929 34.1174">
<g fill={fill}>
	<g>
		<path class="st0" d="M20.0791,8.0945h-1.6899c-0.3822,0-0.692-0.3098-0.692-0.692c0-0.6666-0.5422-1.2093-1.2088-1.2093
			c-0.6666,0-1.2088,0.5428-1.2088,1.2093c0,0.3822-0.3098,0.692-0.692,0.692H9.7169c-0.3822,0-0.692-0.3098-0.692-0.692
			s0.3098-0.692,0.692-0.692h4.2726c0.3033-1.0953,1.3088-1.9013,2.4989-1.9013s2.1956,0.806,2.4989,1.9013h1.0917
			c0.3822,0,0.692,0.3098,0.692,0.692S20.4614,8.0945,20.0791,8.0945z"/>
	</g>
	<g>
		<path class="st0" d="M35.6765,5.5482h-1.5039c-0.3822,0-0.692-0.3098-0.692-0.692c0-0.4746-0.386-0.8606-0.8606-0.8606
			s-0.8606,0.386-0.8606,0.8606c0,0.3822-0.3098,0.692-0.692,0.692h-2.8219c-0.3822,0-0.692-0.3098-0.692-0.692
			s0.3098-0.692,0.692-0.692h2.2392c0.2922-0.9001,1.139-1.5526,2.1354-1.5526c0.9964,0,1.8432,0.6525,2.1354,1.5526h0.9212
			c0.3822,0,0.692,0.3098,0.692,0.692C36.3687,5.2384,36.0588,5.5482,35.6765,5.5482z"/>
	</g>
	<g>
		<path class="st0" d="M27.5702,7.7279h-2.9295c-0.3822,0-0.692-0.3098-0.692-0.692s0.3098-0.692,0.692-0.692h2.9295
			c0.3822,0,0.692,0.3098,0.692,0.692S27.9525,7.7279,27.5702,7.7279z"/>
	</g>
	<g>
		<path class="st0" d="M32.5151,9.0929h-1.2964c-0.3822,0-0.692-0.3098-0.692-0.692c0-0.3822,0.3098-0.692,0.692-0.692h1.2964
			c0.3822,0,0.692,0.3098,0.692,0.692C33.2071,8.7832,32.8973,9.0929,32.5151,9.0929z"/>
	</g>
	<g>
		<path class="st0" d="M46.7718,28.8043H21.7647c-0.3822,0-0.692-0.3098-0.692-0.692s0.3098-0.692,0.692-0.692h25.0071
			c1.9026,0,3.4506-1.5483,3.4506-3.4512V23.581c0-1.7488-5.3365-10.7471-15.3352-10.7471H12.4324
			c-0.3822,0-0.692-0.3098-0.692-0.692s0.3098-0.692,0.692-0.692h22.4549c10.6325,0,16.7191,9.534,16.7191,12.1311v0.3882
			C51.6064,26.6354,49.4375,28.8043,46.7718,28.8043z"/>
	</g>
	<g>
		<path class="st0" d="M48.0076,22.4182h-6.8878c-3.2371,0-5.8709-2.6338-5.8709-5.8709v-2.037h1.3839v2.037
			c0,2.4743,2.0129,4.487,4.487,4.487h6.8878V22.4182z"/>
	</g>
	<g>
		<path class="st0" d="M27.813,19.7411h-5.4379c-0.9528,0-1.7278-0.7752-1.7278-1.7278v-1.8126c0-0.9525,0.775-1.7278,1.7278-1.7278
			h5.4379c0.9528,0,1.7278,0.7752,1.7278,1.7278v1.8126C29.5407,18.9659,28.7658,19.7411,27.813,19.7411z M22.3751,15.8569
			c-0.1862,0-0.3438,0.1573-0.3438,0.3438v1.8126c0,0.1865,0.1576,0.3438,0.3438,0.3438h5.4379
			c0.1862,0,0.3438-0.1573,0.3438-0.3438v-1.8126c0-0.1865-0.1576-0.3438-0.3438-0.3438H22.3751z"/>
	</g>
	<g>
		<path class="st0" d="M16.6588,19.7411h-5.4379v-1.3839h5.4379c0.1862,0,0.3438-0.1573,0.3438-0.3438v-1.8126
			c0-0.1935-0.1606-0.3633-0.3438-0.3633h-3.9442v-1.3839h3.9442c0.9528,0,1.7278,0.7839,1.7278,1.7472v1.8126
			C18.3865,18.9659,17.6116,19.7411,16.6588,19.7411z"/>
	</g>
	<g>
		<rect x="11.5804" y="30.3483" class="st0" width="34.2887" height="1.3839"/>
	</g>
	<g>
		<path class="st0" d="M25.6581,23.5729h-7.3332c-0.3822,0-0.692-0.3098-0.692-0.692s0.3098-0.692,0.692-0.692h7.3332
			c0.3822,0,0.692,0.3098,0.692,0.692S26.0403,23.5729,25.6581,23.5729z"/>
	</g>
	<g>
		<path class="st0" d="M19.1991,28.7951h-3.7815c-0.3822,0-0.692-0.3098-0.692-0.692s0.3098-0.692,0.692-0.692h3.7815
			c0.3822,0,0.692,0.3098,0.692,0.692C19.891,28.4854,19.5813,28.7951,19.1991,28.7951z"/>
	</g>
	<g>
		<path class="st0" d="M9.8315,12.8339H7.8897c-0.3822,0-0.692-0.3098-0.692-0.692s0.3098-0.692,0.692-0.692h1.9418
			c0.3822,0,0.692,0.3098,0.692,0.692S10.2137,12.8339,9.8315,12.8339z"/>
	</g>
	<g>
		<path class="st0" d="M15.8338,23.5729H13.892c-0.3822,0-0.692-0.3098-0.692-0.692s0.3098-0.692,0.692-0.692h1.9418
			c0.3822,0,0.692,0.3098,0.692,0.692S16.216,23.5729,15.8338,23.5729z"/>
	</g>
	<g>
		<path class="st0" d="M11.4004,23.5729h-0.8066c-0.3822,0-0.692-0.3098-0.692-0.692s0.3098-0.692,0.692-0.692h0.8066
			c0.3822,0,0.692,0.3098,0.692,0.692S11.7826,23.5729,11.4004,23.5729z"/>
	</g>
	<g>
		<path class="st0" d="M10.7776,15.8375H9.971c-0.3822,0-0.692-0.3098-0.692-0.692s0.3098-0.692,0.692-0.692h0.8066
			c0.3822,0,0.692,0.3098,0.692,0.692C11.4695,15.5277,11.1598,15.8375,10.7776,15.8375z"/>
	</g>
</g>
</svg>


)

